import React from 'react';
import classes from './styles.module.scss';

const SiteFooterLinks = () => {
  return (
    <footer>
      <div className={classes.footerSection}>
        <a href="/compliance-and-certifications">
          <h5>Compliance & Certificates</h5>
        </a>
      </div>

      <div className={classes.footerSection}>
        <a href="/company-policies">
          <h5>Policies</h5>
        </a>
      </div>
    </footer>
  );
}

export default SiteFooterLinks;
